import { Box, Button, Icon, LinearProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { infoList } from '@/lib/utils/DataFormat';
import RedButton from '@/js/shared/components/ui/RedButton';
import UserAvatar from '@/components/ui/userAvatar';

const useStyles = (theme) => ({
  chatHolder: {
    zIndex: '1400 !important',
    position: 'fixed !important',
    bottom: '180px !important',
    left: '50% !important',
  },
  dialogBg: {
    border: `${theme.palette.background.default} !important`,
    backgroundColor: `${theme.palette.background.shadedown_20} !important`,
    position: 'relative !important',
    left: '-155px !important',
    width: '310px !important',
    borderRadius: '5px !important',
  },
  closeButton: {},
  answerButtons: {
    width: '100% !important',
    '& > *': {
      margin: '5px !important',
    },
  },
  answerAccept: {
    flexGrow: '1 !important',
  },
});

const VideoChatCall = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const title =
    props.data.direction === 'outgoing'
      ? 'Outgoing'
      : props.data.participants.length > 1
      ? 'Group'
      : 'Incoming';

  return (
    <Box sx={classes.chatHolder}>
      <Box sx={classes.dialogBg} p={1}>
        <Box align="center" pb={1}>
          <Typography variant="h6">{title} call</Typography>
        </Box>

        {props.data.participants.map((p, index) => (
          <Box display="flex" alignItems="center" key={index}>
            <Box p={1}>
              <UserAvatar user={p} />
            </Box>
            <Box>
              {p.full_name}
              <br />
              <em>{infoList([p.company, p.location_city])}</em>
            </Box>
          </Box>
        ))}
        {props.data.direction === 'outgoing' ? (
          <Box
            display="flex"
            sx={classes.answerButtons}
            justifyContent="center"
          >
            <RedButton
              sx={classes.answerAccept}
              onClick={() => props.cancelHandler()}
              variant="contained"
              size="small"
              startIcon={<Icon>close</Icon>}
            >
              Cancel
            </RedButton>
          </Box>
        ) : (
          <Box display="flex" sx={classes.answerButtons}>
            <Button
              sx={classes.answerAccept}
              onClick={() => props.answerHandler(true)}
              variant="contained"
              size="small"
              startIcon={<Icon>videocam</Icon>}
              color="primary"
            >
              {props.data.addToCurrent ? 'Add to group' : 'Talk'}
            </Button>
            <RedButton
              onClick={() => props.answerHandler(false)}
              variant="contained"
              size="small"
              startIcon={<Icon>close</Icon>}
            >
              Later
            </RedButton>
          </Box>
        )}

        <LinearProgress />
      </Box>
    </Box>
  );
};

export default VideoChatCall;
